import type { SymbolKey } from '@/entities/symbol';
import { DATAHUB_DEFAULT_GROUP } from '@/features/DataHub/constants/const';

export interface ExportSymbolKey {
  code: SymbolKey['Code'];
  periodType: SymbolKey['PeriodType'];
  timeRef: SymbolKey['TimeRef'];
  period: SymbolKey['Period'];
}

export interface ExportSymbolEntry {
  group: string;
  key: ExportSymbolKey;
}

export interface ExportSymbolsPayload {
  symbols: ExportSymbolEntry[];
}

export function transformSymbols(
  selectedSymbols: SymbolKey[],
  groupName: string = DATAHUB_DEFAULT_GROUP
): ExportSymbolsPayload {
  return {
    symbols: (selectedSymbols || []).map(symbol => ({
      group: groupName,
      key: {
        code: symbol.Code,
        periodType: symbol.PeriodType,
        timeRef: symbol.TimeRef,
        period: symbol.Period
      }
    }))
  };
}
